import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumb from "../../components/Reusable/Breadcrumb";
import { Col, Row } from "react-bootstrap";
import {
  Button,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  FormControl,
} from "@mui/material";
import {
  fetchUpdateUser,
  fetchUpdateUserImage,
  fetchUserInfo,
} from "../../actions/security";
import { useTranslation } from "react-i18next";
import {
  getFileTooLargeMessage,
  isFileTooLarge,
} from "../../utils/fileUpload";
import { toast } from "react-toastify";

const ProfileChange = () => {
  const loggedUserReducer = useSelector((state) => state.loggedUserReducer);
  const image = loggedUserReducer?.loggedUser?.image
    ? loggedUserReducer?.loggedUser?.image
    : "/images/no-user.png";

  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(fetchUserInfo());
  }, [dispatch]);

  //loggedUserReducer.userInfoList

  useEffect(() => {
    setData({
      ...data,
      name: loggedUserReducer.userInfoList.name || "",
      lastName: loggedUserReducer.userInfoList.lastName || "",
      email: loggedUserReducer.userInfoList.email || "",
      phone: loggedUserReducer.userInfoList.phone || "",
      companyName: loggedUserReducer.userInfoList.companyName || "",
      countryName: loggedUserReducer.userInfoList.countryName || "",
      accountType: loggedUserReducer.userInfoList.accountType || "",
      storeName: loggedUserReducer.userInfoList.storeName || "",
      city: loggedUserReducer.userInfoList.city || "",
      image: loggedUserReducer.userInfoList.image || "",
      sector: loggedUserReducer.userInfoList.sector || "",
      address: loggedUserReducer.userInfoList.address || "",
    });
  }, [loggedUserReducer.userInfoList]);

  const [data, setData] = useState({
    name: "",
    lastName: "",
    email: "",
    phone: "",
    companyName: "",
    countryName: "",
    accountType: "",
    storeName: "",
    city: "",
    address: "",
    image: "",
    sector: "",
  });

  const handleSubmit = (event) => {
    event.preventDefault();

    dispatch(fetchUpdateUser(data));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setData((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    event.target.value = "";

    if (!file) return;

    // Profilna slika koristi isti zaštitni limit pre FormData slanja.
    if (isFileTooLarge(file)) {
      toast.error(getFileTooLargeMessage(), { theme: "colored" });
      return;
    }

    const formData = new FormData();
    formData.append("image", file);

    dispatch(fetchUpdateUserImage(formData));
  };

  return (
    <div className="profile-change-main-container">
      <div className="profile-main-container">
        <Breadcrumb title={t("changeProfile.naslov")} returnPage="/settings" />
        <div className="profile-image-holder">
          <div className="profile-image-content">
            <img
              src={data.image || image}
              className="img-fluid profile-image-profile"
              alt="LG"
            />
            <label
              htmlFor="profile-image-upload"
              className="custom-edit-image-profile"
            >
              <img
                src="/images/edit-profile-image.png"
                className="img-fluid icon-change-image-profile"
                alt="Edit"
              />
            </label>
            <input
              type="file"
              id="profile-image-upload"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleImageChange}
            />
          </div>
        </div>
      </div>
      <div className="profile-change-content">
        <form onSubmit={handleSubmit} noValidate>
          <Row>
            <Col xs={12}>
              <TextField
                label={t("changeProfile.tip")}
                name="accountType"
                disabled
                value={
                  data.accountType == "BASIC_USER"
                    ? t("registration.prodavac")
                    : "Menadžer"
                }
                variant="standard"
                onChange={handleInputChange}
                fullWidth
                size="small"
                className="input-field-form mb-3"
              />
            </Col>
            <Col xs={12}>
              <TextField
                label={t("changeProfile.sektor")}
                name="sector"
                disabled
                value={
                  data.sector == "DEVICE_FOR_HOUSE"
                    ? t("registration.sector_name_1")
                    : data.sector == "TV_AUDIO"
                    ? t("registration.sector_name_2")
                    : t("registration.sector_name_3")
                }
                variant="standard"
                onChange={handleInputChange}
                fullWidth
                size="small"
                className="input-field-form mb-3"
              />
            </Col>
            <Col xs={12}>
              <TextField
                required
                label={t("changeProfile.ime")}
                name="name"
                value={data.name}
                variant="standard"
                onChange={handleInputChange}
                fullWidth
                size="small"
                className="input-field-form mb-3"
              />
            </Col>
            <Col xs={12}>
              <TextField
                required
                label={t("changeProfile.prezime")}
                variant="standard"
                name="lastName"
                value={data.lastName}
                onChange={handleInputChange}
                fullWidth
                size="small"
                className="input-field-form mb-3"
              />
            </Col>
            <Col xs={12}>
              <TextField
                type="email"
                disabled
                variant="standard"
                label={t("changeProfile.email")}
                name="email"
                value={data.email}
                fullWidth
                size="small"
                className="input-field-form mb-3"
              />
            </Col>
            <Col xs={12}>
              <TextField
                variant="standard"
                label="Telefon"
                name="phone"
                value={data.phone}
                onChange={handleInputChange}
                fullWidth
                size="small"
                className="input-field-form mb-3"
              />
            </Col>
            <Col xs={12}>
              <TextField
                variant="standard"
                label={t("changeProfile.grad")}
                name="city"
                value={data.city}
                onChange={handleInputChange}
                fullWidth
                size="small"
                className="input-field-form mb-3"
              />
            </Col>
            <Col xs={12}>
              <TextField
                variant="standard"
                label={t("changeProfile.adresa")}
                name="address"
                value={data.address}
                onChange={handleInputChange}
                fullWidth
                size="small"
                className="input-field-form mb-3"
              />
            </Col>
            <Col xs={12}>
              <TextField
                variant="standard"
                label={t("changeProfile.kompanija")}
                name="companyName"
                disabled
                value={data.companyName}
                fullWidth
                size="small"
                className="input-field-form mb-3"
              />
            </Col>
            <Col xs={12}>
              <TextField
                variant="standard"
                label={t("changeProfile.radnja")}
                name="storeName"
                disabled
                value={data.storeName}
                fullWidth
                size="small"
                className="input-field-form mb-3"
              />
            </Col>
          </Row>

          <div className="button-registration-holder">
            <Button type="submit" fullWidth size="small">
              {t("changeProfile.save")}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProfileChange;
